import {useDispatch, useSelector} from 'react-redux'
import {AppStore} from '../redux/store'
import {
  addTabAction,
  changeTabAction,
  deleteTabAction,
  setCurrentTabItemAction,
  setMenuFromApi,
} from '../redux/states/lavanderia'
import {TabLavanderiaModel} from '../models'
export const useLavanderia = () => {
  const lavanderiaState = useSelector((store: AppStore) => store.lavanderia)
  const {tabs, currentTab} = lavanderiaState
  const currentTabItem = tabs[currentTab] || null
  const dispatch = useDispatch()

  const changeTab = (index: number) => {
    dispatch(changeTabAction(index))
  }

  const changeCurrentTabItem = (tab: TabLavanderiaModel) => {
    dispatch(setCurrentTabItemAction(tab))
  }

  const addTab = (newTab: TabLavanderiaModel) => {
    dispatch(addTabAction(newTab))
    return lavanderiaState.tabs.length
  }

  const deleteTab = (index: number) => {
    const updatedTabs = [...tabs]
    updatedTabs.splice(index, 1)
    dispatch(deleteTabAction(updatedTabs))
  }
  const setMenu = (menu: any[]) => {
    dispatch(setMenuFromApi(menu))
  }
  const isAllowed = (action: string) => {
    return currentTabItem.opciones?.some((item) => item.opcion === action)
  }
  return {
    panel: lavanderiaState.showPanel,
    currentTabItem,
    tabs: lavanderiaState.tabs,
    currentTab: lavanderiaState.currentTab,
    menu: lavanderiaState.menu,
    addTab,
    deleteTab,
    changeTab,
    changeCurrentTabItem,
    setMenu,
    isAllowed,
  }
}
